import Vue from 'vue'
import http, { expandURI } from '@/utils/ajax'
import { MYINFORCECHART_INIT_LOADING, MYINFORCECHART_INIT_SUCCESS, MYINFORCECHART_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'

const state = {
  myInforceChart: {
    init: 0,
    menu: {},
    lastUpdated: null,
    scope: null,
    appId: null,
    info: null,
    appIds: [],
    chartInfo: []
  }
}

const getters = {

}

const actions = {
  async initMyInforceChart({ commit, state }, data) {
    commit(MYINFORCECHART_INIT_LOADING)
    const apiUrl = state.permitWidgets.myInforceChart
    if (apiUrl) {
      try {
        let params = {
          scope: data.scope,
          appId: data.appId
        }
        const result = await http.get(expandURI(apiUrl, params))
        const menu = extractMenu(result.data._links)

        Object.assign(data, {
          menu: menu,
          info: result.data.info,
          appIds: result.data.appIds,
          chartInfo: result.data.chartInfo
        })
        commit(MYINFORCECHART_INIT_SUCCESS, data)
      } catch (error) {
        commit(MYINFORCECHART_INIT_FAIL)
      }
    } else {
      commit(MYINFORCECHART_INIT_FAIL)
    }
  }
}

const mutations = {
  [MYINFORCECHART_INIT_LOADING](state) {
    state.myInforceChart.init = 0
  },
  [MYINFORCECHART_INIT_SUCCESS](state, data) {
    const { myInforceChart } = state
    myInforceChart.menu = data.menu
    myInforceChart.init = 1
    myInforceChart.lastUpdated = new Date()
    myInforceChart.scope = data.scope
    myInforceChart.appId = data.appId
    myInforceChart.info = data.info
    myInforceChart.appIds = data.appIds
    Vue.set(myInforceChart, 'chartInfo', data.chartInfo)
  },
  [MYINFORCECHART_INIT_FAIL](state) {
    state.myInforceChart.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
